<template>
  <div class="folder">
    <VueLabel isFolder="true" :isRoot="isRoot" :Key="Key" :Name="folderData[Key].Title" :path="path" :canEdit="canEdit"></VueLabel>
    <input class="folderCheck" type="checkbox" :id="'folder' + Key" v-model="isChecked" />
    <Folder v-show="isChecked" v-for="(folder, index) in subFolders" :Key="Object.keys(folder)[0]" :path="folder.Path" :folderData="folder" :canEdit="canEdit"></Folder>
    <VueLabel v-show="isChecked" isFile="true" class="file" v-for="(file, index) in files" :Key="file.Key" :path="file.Path" :Name="file.Title" :Url="file.Url" :canEdit="canEdit"></VueLabel>
  </div>
</template>
<script>
  import VueLabel from '../components/FileFolderLabel';
  export default {
    name: 'Folder',
    components: { VueLabel },
    props: ['folderData', 'Key', 'isRoot', 'path', 'canEdit'],
    data() {
      return {
        isChecked: true,
      }
    },
    created() {
      this.$Log("Vue [Folder] is created ...");
    },
    ready() {
      this.$Log("Vue [Folder] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Folder] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Folder] is updated ...");
    },
    computed: {
      subFolders() {
        var arrFolders = [];
        if (this.folderData[this.Key].SubFolders) {
          var keys = Object.keys(this.folderData[this.Key].SubFolders);
          for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            var folder = {};
            folder[key] = this.folderData[this.Key].SubFolders[key];
            folder.Path = this.path + "/SubFolders/" + key;
            arrFolders.push(folder);
          }
        }
        return arrFolders;
      },
      files() {
        var arrFiles = [];
        if (this.folderData[this.Key].Files) {
          var keys = Object.keys(this.folderData[this.Key].Files);
          for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            var file = {
              Key: key,
              Title: this.folderData[this.Key].Files[key].Title,
              Url: this.folderData[this.Key].Files[key].Url,
              Path: this.path + "/Files/" + key
            };
            arrFiles.push(file);
          }
        }
        return arrFiles;
      }
    },
    methods: {
    }
  }
</script>
<style>
  .folder {
    margin-right: 20px;
    position: relative;
  }

  .folderCheck {
    position: absolute;
    /*left: 0;
      margin-left: 0;*/
    right: 0;
    right: 10px;
    margin-right: 0;
    opacity: 0;
    z-index: 20;
    cursor: pointer;
    height: 1em;
    width: 1em;
    top: 3px;
  }
</style>



// WEBPACK FOOTER //
// Folder.vue?158070aa